// removed by extract-text-webpack-plugin
module.exports = {"form":"_1-oEI","header":"_ESF1","moreButton":"_4xOqd","footer":"_2G7s4","editorControls":"JB4DT","buttons":"-hosk","button":"_1p7bI","wrapper":"ir4O6","titleInputWrapper":"k4XZN","titleInput":"UnITK","mainArea":"_1XDF8","content":"_1wqNS"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-form/post-form.scss
// module id = 843
// module chunks = 3 4 5 6 7